export default __webpack_public_path__ + "static/USDC-2ebc0b629b6ce812dfa49c56d62f89f9.jpg";